export enum answersPageActionTypes {
  SET_IS_OPEN_ANSWERS_DELETE_MODAL = 'SET_IS_OPEN_ANSWERS_DELETE_MODAL',
  SET_IS_OPEN_MARK_AS_SENT_MODAL = 'SET_IS_OPEN_MARK_AS_SENT_MODAL',
  SET_ANSWERS_PAGE_NUMBER = 'SET_ANSWERS_PAGE_NUMBER',
  SET_ROWS_PER_PAGE = 'SET_ROWS_PER_PAGE',
  SET_ANSWERS_FILTERS = 'SET_ANSWERS_FILTERS',
  RESET_ANSWERS_FILTERS = 'RESET_ANSWERS_FILTERS',
}
